const Tabs = (function (window, $) {

    function Tabs() {
        this.tabButtonsWrap = $('.tab-buttons.has-js');
        this.tabButtons = this.tabButtonsWrap.find('a');
        this.tabContent = $('.tab-content > div');
        this.tabOffsetPos = $('.tab-selection.active');
        this.tabButtonsUl = $('.tab-buttons ul');
        this.tabBooksSection = $('.section-book-list-tabs');
        this.tabBooksFreeContentSection = $('.section-free-content .tabs-container');

        let firstTab = this.tabButtons.first().data('tab'); // done for the tabs

        if (this.tabBooksSection.length === 1) {
            this.toggleTab(firstTab)
        } else if (this.tabBooksSection.length > 1) {
            for (let i = 0; i < this.tabBooksSection.length; i++) {
                const $parent = $(this.tabBooksSection[i]);
                firstTab = $parent.find('.tab-buttons.has-js a').first().data('tab');
                this.toggleTab(firstTab, $parent);
            }
        } else if (this.tabBooksFreeContentSection.length) {
            this.toggleTab(firstTab)
        } else {
            this.toggleTab();
        }
        this.handlePos();
        this.viewPortCheck();
        this.addEvents();
    }

    Tabs.prototype.addEvents = function () {
        this.tabButtons.on('click', this.handleClick.bind(this));
        $(window).on('resize', this.viewPortCheck.bind(this));
    }

    Tabs.prototype.viewPortCheck = function () {
        if (this.tabButtonsWrap.isWiderThanViewport()) {
            this.tabButtonsWrap.closest('.section-free-content').addClass('is-wider-than-vp');
        } else {
            this.tabButtonsWrap.closest('.section-free-content').removeClass('is-wider-than-vp');
        }
    }

    Tabs.prototype.handleClick = function (e) {
        e.preventDefault();

        let target = $(e.target).closest('a');
        let tab = target.data('tab');

        const $parent = target.closest('.section-book-list-tabs, .section-free-content');
        this.toggleTab(tab, $parent);
    }

    Tabs.prototype.handlePos = function () {
        if (this.tabButtonsUl.length > 0) {
            let offSetPos = this.tabOffsetPos.offset().left;
            this.tabButtonsUl.scrollLeft(offSetPos);
        }
    }

    Tabs.prototype.toggleTab = function (tab, $parent = null) {
        let button = this.tabButtonsWrap.find(`[data-tab=${tab}]`);
        let tabEl = $('#' + tab);

        if (button.length && tabEl.length) {
            if ($parent !== null) {
                $parent.find('.tab-buttons a').removeClass('active');
                $parent.find('.tab-content > div').removeClass('active');
            } else {
                this.tabButtons.removeClass('active');
                this.tabContent.removeClass('active');
            }

            button.addClass('active');
            tabEl.addClass('active');
        }
    }

    return Tabs;

}(window, jQuery));


export {Tabs};
